"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "makeClassnames", {
  enumerable: true,
  get: function get() {
    return _classnames.default;
  }
});
Object.defineProperty(exports, "makeClassesObject", {
  enumerable: true,
  get: function get() {
    return _classnames.makeClassesObject;
  }
});
Object.defineProperty(exports, "makeFlagIconOptions", {
  enumerable: true,
  get: function get() {
    return _options.default;
  }
});
Object.defineProperty(exports, "makeStyles", {
  enumerable: true,
  get: function get() {
    return _styles.default;
  }
});
exports.constants = exports.countries = void 0;

var _classnames = _interopRequireWildcard(require("./classnames"));

var _options = _interopRequireDefault(require("./options"));

var _styles = _interopRequireDefault(require("./styles"));

var _countries = _interopRequireWildcard(require("./countries"));

exports.countries = _countries;

var _constants = _interopRequireWildcard(require("./constants"));

exports.constants = _constants;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }


//////////////////
// WEBPACK FOOTER
// ./~/react-flag-icon-css/lib/functions/index.js
// module id = 98
// module chunks = 168707334958949